// extracted by mini-css-extract-plugin
export default {"medicine":"MedicineOrder_medicine__0PBLk"};